// removed by extract-text-webpack-plugin
module.exports = {"Footer":"style__Footer___3Y-3u","FooterLink":"style__FooterLink___26Q-E","FooterDeveloper":"style__FooterDeveloper___3N-q_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.scss
// module id = 1331
// module chunks = 0